"use strict";
// requestSubmit for Safari <16
;
(function (prototype) {
    if (typeof prototype.requestSubmit == 'function')
        return;
    function validateSubmitter(submitter, form) {
        if (!(submitter instanceof HTMLElement))
            throw new TypeError("parameter 1 is not of type 'HTMLElement'");
        if (submitter.getAttribute('type') !== 'submit')
            throw new TypeError('The specified element is not a submit button');
        if (submitter.getAttribute('form') !== form)
            throw new DOMException('The specified element is not owned by this form element', 'NotFoundError');
    }
    prototype.requestSubmit = function (submitter) {
        if (submitter) {
            validateSubmitter(submitter, this);
            submitter.click();
        }
        else {
            submitter = document.createElement('input');
            submitter.setAttribute('type', 'submit');
            submitter.hidden = true;
            this.appendChild(submitter);
            submitter.click();
            this.removeChild(submitter);
        }
    };
})(HTMLFormElement.prototype);
